import { API } from "aws-amplify";

/**
 * Google Places API key for address autocomplete.
 * Local: REACT_APP_GOOGLE_PLACES_API_KEY in .env.local (CRA; VITE_* is not injected).
 * Deployed: Amplify developerApi GET /google-places-key
 *   → SSM `${KEYS}GOOGLE_PLACES_API_KEY` (no extra Lambda env var; Lambda 4KB limit).
 */
export async function getGooglePlacesApiKey() {
  const fromEnv =
    process.env.REACT_APP_GOOGLE_PLACES_API_KEY ||
    process.env.VITE_GOOGLE_PLACES_API_KEY;
  if (typeof fromEnv === "string" && fromEnv.trim()) {
    return fromEnv.trim();
  }

  try {
    const data = await API.get("developerApi", "/google-places-key");
    return typeof data?.apiKey === "string" && data.apiKey.trim()
      ? data.apiKey.trim()
      : null;
  } catch {
    return null;
  }
}
